import { createFileRoute } from "@tanstack/react-router";
import { blogRouteOptions } from "@/components/blog/blogRouteOptions";

export const Route = createFileRoute("/how-we-turned-around-carage-auto")(blogRouteOptions("how-we-turned-around-carage-auto"));
